import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

export const useControlTowerStore = defineStore('controlTower', {
  state,
  getters,
  actions
})

export default useControlTowerStore
